import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/anchor-heading/anchor-heading.js'

const tagName = 'dap-ds-anchor-heading'

/**
 * `dap-ds-anchor-heading`
 * @summary Anchor heading is a heading with an anchor link.
 * @element dap-ds-anchor-heading
 * @title - Anchor heading
 *
 * @attribute {'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'} variant - The variant of the heading. Default is `h2`. Can be `h1`, `h2`, `h3`, `h4`, `h5`, or `h6`.
 * @attribute {string} label - The label of the heading.
 *
 * @csspart base - The main anchor heading container.
 * @csspart link - The link of the anchor heading. dap-ds-link element.
 * @csspart link-base - The base of the link part.
 * @csspart text - The text of the anchor heading.
 *
 * @cssproperty --dds-anchor-link-color - The color of the anchor link (default: var(--dds-color-primary))
 * @cssproperty --dds-anchor-link-opacity - The opacity of the anchor link when not hovered (default: 0)
 * @cssproperty --dds-anchor-link-hover-opacity - The opacity of the anchor link when hovered (default: 1)
 * @cssproperty --dds-anchor-link-transition - The transition property for the anchor link opacity (default: opacity 0.2s ease-in-out)
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSAnchorHeading',
})

export default reactWrapper
